import {
  Outlet,
  redirect,
  useLoaderData,
  useNavigate,
  useNavigation,
} from "react-router-dom";
import { createContext, useContext, useState, useEffect } from "react";
import Wrapper from "../assets/wrappers/Dashboard";
import { Navbar, BigSidebar, SmallSidebar, Loading } from "../components";
import { customFetch } from "../utils/custom-fetch";
import { toast } from "react-toastify";

/* ---------- loader – מאמת משתמש ומפנה אם לא מחובר/מאושר ---------- */
export const loader = async () => {
  try {
    const { data } = await customFetch.get("/users/current-user");
    if (!data.user?.isVerified) {
      return redirect(`/verify-email/${data.user._id}`);
    }
    return data; // {user}
  } catch {
    return redirect("/"); // לא מחובר
  }
};

const DashboardContext = createContext();
export const useDashboardContext = () => useContext(DashboardContext);

const DashboardLayout = ({ isDarkThemeEnabled }) => {
  const { user } = useLoaderData();
  const navigation = useNavigation();
  const navigate = useNavigate();

  /* UI state */
  const [showSidebar, setShowSidebar] = useState(false);
  const [isDarkTheme, setIsDarkTheme] = useState(isDarkThemeEnabled);
  const [isAuthError, setIsAuthError] = useState(false);

  /* ----- פונקציות UI ----- */
  const toggleSidebar = () => setShowSidebar((prev) => !prev);
  const toggleDarkTheme = () => {
    const val = !isDarkTheme;
    setIsDarkTheme(val);
    document.body.classList.toggle("dark-theme", val);
    localStorage.setItem("darkTheme", val);
  };

  /* ----- התנתקות ----- */
  const logoutUser = async () => {
    try {
      await customFetch.get("/auth/logout");
    } catch (_) {}
    toast.success("התנתקת בהצלחה");
    navigate("/login");
  };

  /* ----- Axios interceptor: מפנה אם קיבלנו 401 ----- */
  useEffect(() => {
    const resInterceptor = customFetch.interceptors.response.use(
      (res) => res,
      (error) => {
        if (error?.response?.status === 401) setIsAuthError(true);
        return Promise.reject(error);
      }
    );
    return () => customFetch.interceptors.response.eject(resInterceptor);
  }, []);

  /* אחרי שסומן 401 → התנתק */
  useEffect(() => {
    if (isAuthError) logoutUser();
  }, [isAuthError]);

  const isPageLoading = navigation.state === "loading";

  return (
    <DashboardContext.Provider
      value={{
        user,
        showSidebar,
        isDarkTheme,
        toggleDarkTheme,
        toggleSidebar,
        logoutUser,
      }}
    >
      <Wrapper>
        <main className="dashboard">
          <SmallSidebar />
          <BigSidebar />
          <div>
            <Navbar />
            <div className="dashboard-page">
              {isPageLoading ? <Loading /> : <Outlet context={{ user }} />}
            </div>
          </div>
        </main>
      </Wrapper>
    </DashboardContext.Provider>
  );
};

export default DashboardLayout;
